module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-07-ee569b5209118135558cd7411ee72979.jpg";